import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RestService } from '../../../core/services/rest.service';
import { ToasterService } from '../../../core/services/toaster-service';
import { MaterialModule } from '../../../core/shared/material.module';
import { MessageEnum } from '../../../core/utils/message.enum';

@Component({
  selector: 'app-agent-setup-info',
  standalone: true,
  imports: [CommonModule, MaterialModule],
  templateUrl: './agent-setup-info.component.html',
  styleUrl: './agent-setup-info.component.scss'
})
export class AgentSetupInfoComponent {
  activeModal = inject(NgbActiveModal);
  isActive: boolean = false;

  constructor(
    private readonly restService: RestService,
    private readonly toaster: ToasterService
  ) {}
  
    @Input()
    key: any = {};

    @Input()
    projectId: string = '';

    downloadExtentioComponent() {
      this.restService.getAgentExtention(this.projectId).subscribe((item: any) => {
        console.log("Download URL", item?.data);
        window.open(item?.data, "_blank");
      });
    }

    copyToClipboard(value: any): void {
        // Use Clipboard API to copy text
        navigator.clipboard
          .writeText(value)
          .then(() => {
            this.toaster.pop({ type: 'success', text: MessageEnum.AGENT_TOKEN_COPY_SUCCESS }, { backgroundColor: 'white' });
          })
          .catch((err) => {
            console.error(err);
          });
      }
}
